import React, { useEffect, useState } from 'react'
import Layout from '../../../Components/Layout'
import Breadcrumb from '../Component/Breadcrumb'
import Sidebar from '../../Dashboard/Component/Siderbar'
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../../config';

export default function ProfileSettings() {
    const [preview, setPreview] = useState("assets/img/users/user-lg-26.jpg");
    const [loading, setLoading] = useState(false);
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        username: "",
        profile_photo: null,
        email: "",
        phone: "",
    });
    const [selectedImage, setSelectedImage] = useState(null);
    const [image, setImage] = useState(null);

    const fetchAgencyDetails = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${config.API_BASE_URL_V1}profile/me`,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                    },
                }
            );
            const profile = response.data.data;
            console.log('profile: ',profile)
            // Gelen verileri formData'ya aktar
            setFormData({
                name: profile.name || "",
                surname: profile.surname || "",
                username: profile.username || "",
                profile_photo: profile.profile_photo || null,
                email: profile.email || "",
                phone: profile.phone || "",
            });

            // Profil fotoğrafı varsa önizlemeyi güncelle
            if (profile.profile_photo) {
                setPreview(profile.profile_photo);
            }
        } catch (error) {
            console.error("Error fetching agency details:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch agency details',
            });
        } finally {
            setLoading(false);
        }
    };
    useEffect(()=> {
        fetchAgencyDetails();
    },[])

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === "file") {
            const file = files[0];
            if (file) {
                setImage(file);
                setSelectedImage(URL.createObjectURL(file)); // Anlık görsel önizleme
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        const token = userData.token; // Kullanıcı tokeni
    
        try {
            // Eğer profile_photo seçilmişse önce fotoğraf güncelleme isteğini at
            if (image) {
                const imageData = new FormData();
                imageData.append("profilePhoto", image);
    
                const photoResponse = await axios.post(`${config.API_BASE_URL_V1}profile/change-profile-photo`,
                    image,
                    {
                        headers: {
                            Authorization: `Bearer ${userData.token}`,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
    
                console.log("Profile photo updated:", photoResponse.data);
            }
    
            // Kullanıcı bilgilerini güncelleme
            const userDataUpdate = {
                name: formData.name,
                surname: formData.surname,
                username: formData.username,
                phone: formData.phone,
                email: formData.email,
            };
    
            const userResponse = await axios.post(`${config.API_BASE_URL_V1}profile/update`,
                userDataUpdate,
                {
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
    
            console.log("User profile updated:", userResponse.data);
    
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Profile updated successfully!",
            });
    
        } catch (error) {
            console.error("Error updating profile:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to update profile",
            });
        } finally {
            setLoading(false);
        }
    };
    

    
  return (
    <Layout>
        <Breadcrumb title="Account Manager" />
        <div className="content">
            <div className="container">
                <div className="row">
                    <Sidebar>
                        <div className="row">
                            <div className="col-12">
                                <div className="card" id="basic_info">
                                    <div className="card-header">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h5 className="fs-18">Account Manager</h5>
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="card-body pb-1">
                                            <div className="row">
                                                {/* Thumbnail Upload */}
                                                <div className="col-md-6 d-flex flex-column align-items-center" style={{ padding: "15px" }}>
                                                    <img
                                                        style={{ width: "200px", height: "150px", borderRadius: "8px", marginBottom: "25px", objectFit: "cover" }}
                                                        src={selectedImage || formData.profile_photo || "assets/img/users/user-lg-26.jpg"}
                                                        alt="Thumbnail"
                                                        className="img-fluid"
                                                    />

                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Thumbnail</label>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                accept="image/*"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Input Fields */}
                                                <div className="col-md-6 d-flex flex-column gap-2">
                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="name"
                                                                value={formData.name}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Surname</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="surname"
                                                                value={formData.surname}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">Username</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="username"
                                                                value={formData.username}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Email</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            required
                                                            email
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Phone</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="phone"
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Submit Button */}
                                            <div className="mt-3 mb-3">
                                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                                    {loading ? "Loading..." : "Save Changes"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </Sidebar>
                </div>
            </div>
        </div>
    </Layout>
  )
}
